var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.175823 5.95989L0.536142 6.32305C0.649542 6.43646 0.800413 6.49894 0.961658 6.49894C1.12281 6.49894 1.27386 6.43646 1.38726 6.32305L5.49754 2.20878L9.61256 6.32761C9.72578 6.44103 9.87683 6.50342 10.038 6.50342C10.1991 6.50342 10.3503 6.44103 10.4636 6.32761L10.824 5.96669C11.0587 5.73198 11.0587 5.34966 10.824 5.11496L5.92458 0.193356C5.81136 0.0800309 5.66049 0.000183582 5.4979 0.000183582H5.49602C5.33478 0.000183582 5.1839 0.0801201 5.07068 0.193356L0.175823 5.10162C0.0624237 5.21495 0.000179291 5.37052 0 5.53183C0 5.69322 0.0624237 5.84665 0.175823 5.95989Z",
    fill: "#225AAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.4bee64242f809d57ac041b7b1a692870.svg";
export { ForwardRef as ReactComponent };